const normalizeBasePath = (value: string) => {
  if (!value || value === ".") {
    return "";
  }

  const withLeadingSlash = value.startsWith("/") ? value : `/${value}`;
  return withLeadingSlash.replace(/\/$/, "");
};

export const getRouterBasename = () => {
  const configuredBase = process.env.REACT_APP_ROUTER_BASENAME || process.env.PUBLIC_URL || "";
  const basename = normalizeBasePath(configuredBase);

  return basename || undefined;
};
